import { ApiTransactionAPIModelStatusEnum as TransactionAPIModelStatusEnum } from '@/generated/api/fps/core';
import { MoneyType, PhoneType, TransactionId, Value } from '@/model/common';
import { actionCreator } from '@/utils/redux';

import {
  CachedWithdrawalData,
  NAMESPACE,
  Timing,
  TransferFormDataCache,
  WalletId,
  WithdrawalForm,
  WithdrawalStep,
} from './types';

const creator = actionCreator(NAMESPACE);

export interface StoreInitActionPayload {
  data?: CachedWithdrawalData;
  status?: TransactionAPIModelStatusEnum;
  sbpId?: string;
  step?: WithdrawalStep;
}

export interface SavePhoneActionPayload {
  phone: PhoneType;
}

export type StorePhoneActionPayload = Value<PhoneType>;

export interface StoreStepActionPayload {
  status?: TransactionAPIModelStatusEnum;
  step?: WithdrawalStep;
  sbpId?: string;
  transactionId?: TransactionId;
}

export interface SaveWithdrawalFormDataActionPayload {
  amount?: MoneyType;
  wallet?: WalletId;
  bank?: string;
  message?: string;
}

export type StoreWithdrawalDataActionPayload = WithdrawalForm;
export type StoreTransferCacheActionPayload = TransferFormDataCache;
export type StoreTimingDataActionPayload = { timing?: Timing };

// sagas
export const init = creator.asyncAction<void>('INIT');
export const savePhone = creator.asyncActionWithPayload<SavePhoneActionPayload, WithdrawalForm>('SAVE_PHONE');
export const saveWithdrawalFormData = creator.asyncActionWithPayload<
  SaveWithdrawalFormDataActionPayload,
  WithdrawalForm
>('SAVE_WITHDRAWAL');
export const proceedToForm = creator.asyncAction<WithdrawalForm>('PROCEED_TO_FORM');
export const prepare = creator.asyncAction<WithdrawalForm>('PREPARE');
export const transfer = creator.asyncAction<WithdrawalForm>('TRANSFER');

// reducers
export const storeInitialized = creator.syncActionWithPayload<StoreInitActionPayload>('STORE_INIT');
export const storePhone = creator.syncActionWithPayload<StorePhoneActionPayload>('STORE_PHONE');
export const storeWithdrawal = creator.syncActionWithPayload<StoreWithdrawalDataActionPayload>('STORE_WITHDRAWAL');
export const storeCache = creator.syncActionWithPayload<StoreTransferCacheActionPayload>('STORE_TRANSFER_CACHE');
export const storeTiming = creator.syncActionWithPayload<StoreTimingDataActionPayload>('STORE_TIMING');
export const storeStep = creator.syncActionWithPayload<StoreStepActionPayload>('STORE_STEP');
export const storeCleanWithdrawal = creator.syncAction('STORE_CLEAN_WITHDRAWAL');
export const storeLogout = creator.syncAction('STORE_LOGOUT');

// notifications
export const notifyWithdrawalFinished = creator.syncAction('WITHDRAWAL_FINISHED');
export const notifyInitializationFinished = creator.syncAction('INIT_FINISHED');

export default {
  init,
  savePhone,
  saveWithdrawalFormData,
  proceedToForm,
  prepare,
  transfer,
  storeInitialized,
  storePhone,
  storeWithdrawal,
  storeCache,
  storeTiming,
  storeStep,
  storeCleanWithdrawal,
  storeLogout,
  notifyInitializationFinished,
  notifyWithdrawalFinished,
};
